import { BuildingThreeIcon, FamilyIcon } from '@repo/ui/icons'

import { LocaleKeys } from '../../../../locale/translation-types'

export enum FriendPlaceEnum {
  SAME_FAMILY = 'SAME_FAMILY',
  SAME_CENTER = 'SAME_CENTER'
}

type FriendPlaceEnumMappingType = {
  label: LocaleKeys
  title: string
  icon: React.ComponentType<{ color?: string; size?: number }>
}

export const friendPlaceEnumMapping: Record<FriendPlaceEnum, FriendPlaceEnumMappingType> = {
  [FriendPlaceEnum.SAME_FAMILY]: {
    label: 'friend.place.enum.SAME_FAMILY',
    title: 'FH',
    icon: FamilyIcon
  },
  [FriendPlaceEnum.SAME_CENTER]: {
    label: 'friend.place.enum.SAME_CENTER',
    title: 'CENTRE',
    icon: BuildingThreeIcon
  }
}
